export default function TrustStrip() {
  const trustItems = [
    'Aligned with Better Placed',
    'Connecting with Country in practice',
    'NSW project delivery teams',
    'Cultural safety & ICIP',
    'Practical implementation focus',
    'Aligned with Better Placed',
    'Connecting with Country in practice',
    'NSW project delivery teams',
    'Cultural safety & ICIP',
    'Practical implementation focus',
  ];

  return (
    <div className="bg-[#E8C580] py-8 overflow-hidden">
      <div className="flex animate-scroll">
        {trustItems.map((item, index) => (
          <div key={index} className="flex items-center whitespace-nowrap px-8">
            <span className="text-[#0E0503] font-medium text-base">{item}</span>
            {index < trustItems.length - 1 && (
              <div className="w-px h-6 bg-[#BA3D03] opacity-40 ml-8"></div>
            )}
          </div>
        ))}
      </div>
      
      <style>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        
        .animate-scroll {
          animation: scroll 30s linear infinite;
        }
        
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
}
